module.exports = __webpack_public_path__ + "img/bg_main0604.5dae6c37.png";